import styled from 'styled-components';

export default styled.section`
  padding: 0 ${props => props.theme.padding.inner};
  position: relative;

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 55%;
    background: ${props => props.theme.colors.blue10};
    z-index: -1;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      height: 75%;
    }
  }

  > .inner {
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};
    position: relative;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.post};
    }

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transition: all 0.4s ease-in-out;
        transform: translateY(10px);
      }
    }

    .active& {
      opacity: 1;
      transform: none;
    }

    .block-featured_media--video& {
      cursor: pointer;
    }

    > picture {
      display: block;
      position: relative;
      box-sizing: border-box;
      padding-top: 55%;
      height: 0;
      width: 100%;
      border-radius: 4px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        object-fit: cover;
      }
    }

    .play-btn {
      position: absolute;
      top: 55%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
